import React from 'react';
import { Button, Modal } from 'gatorcomponents';
import * as Styles from './LogoBuilderSuccessModal.styles';
import IconGear from './iconGear';
import useLocale from '@/hooks/useLocale';
import { logoBuilderAnalytics } from '@/analytics/logoBuilder';

const LogoBuilderSuccessModal = ({
  onClose = () => { },
}) => {
  const { logoBuilder } = useLocale();

  const handleOnClose = (buttonClick) => {
    onClose();
    buttonClick ? logoBuilderAnalytics.logoRequestedOk() : logoBuilderAnalytics.logoRequestedCloseModal();
  };

  return (
    <Modal onClose={handleOnClose} maxWidth={752} testId="logo-builder-success-modal">
      <Styles.Wrapper>

        <IconGear />

        <Styles.Title data-testid="title">{logoBuilder.infosLogoBuilderSuccessModal.title}</Styles.Title>
        <Styles.Message data-testid="message">{logoBuilder.infosLogoBuilderSuccessModal.message}</Styles.Message>

        <Styles.ButtonContainer>
          <Button
            testId="button-ok"
            variant="primary"
            label={logoBuilder.infosLogoBuilderSuccessModal.buttonLabel}
            onClick={() => handleOnClose(true)}
            size="large"
          />
        </Styles.ButtonContainer>

      </Styles.Wrapper>

    </Modal>
  );
};

export default LogoBuilderSuccessModal;
